import React from 'react';

import { IonSkeletonText } from '@ionic/react';

import { IDescriptionText } from './interfaces';

export const DescriptionSkeleton: React.FC<IDescriptionText> = ({
  value,
  ...props
}) => {
  return <IonSkeletonText animated={true} {...props} />;
};
